/**
 * Infrastructure Trends Module
 * Feature: 021-infrastructure-data-collection (T067)
 * 
 * Exports all components for the Infrastructure Trends page.
 * Wraps main page with ErrorBoundary for graceful error handling.
 */

import React from 'react';
import { ErrorBoundary } from '../../components/error';
import { InfrastructureTrendsPage as BasePage } from './InfrastructureTrendsPage';

// Wrap InfrastructureTrendsPage with ErrorBoundary (T067)
const InfrastructureTrendsPageWithErrorBoundary: React.FC = () => (
  <ErrorBoundary name="InfrastructureTrends" showReportButton={true}>
    <BasePage />
  </ErrorBoundary>
);

export { InfrastructureTrendsPageWithErrorBoundary as InfrastructureTrendsPage };
export { InfrastructureTrendsPageWithErrorBoundary as default };
export { TrendChart } from './TrendChart';
export { AnomalyList } from './AnomalyList';
export { ExportDialog } from './ExportDialog';
export type { TrendDataPoint, TrendChartProps } from './TrendChart';
export type { Anomaly, AnomalyListProps, ChangeType, Severity } from './AnomalyList';
